var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M11.142 6.071h7.787a1.071 1.071 0 0 1 0 2.143h-7.787a2.142 2.142 0 0 1-3.712 0H6.07a1.071 1.071 0 1 1 0-2.143H7.43a2.142 2.142 0 0 1 3.712 0ZM6.072 18.93a1.071 1.071 0 0 1 0-2.143H7.43a2.142 2.142 0 0 1 3.712 0h7.787a1.071 1.071 0 0 1 0 2.143h-7.787a2.142 2.142 0 0 1-3.712 0H6.07ZM20 12.5c0 .592-.48 1.071-1.071 1.071H17.57a2.142 2.142 0 0 1-3.713 0H6.071a1.071 1.071 0 1 1 0-2.142h7.787a2.142 2.142 0 0 1 3.712 0h1.359c.591 0 1.071.48 1.071 1.071Z",
    clipRule: "evenodd"
  })));
};
export default SvgFilters;